const CACHE_PREFIX = 'cfd_shop_logo_'

function storage(): Storage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}

function cacheKey(placeId: string): string {
  return `${CACHE_PREFIX}${placeId}`
}

export const logoCache = {
  read(placeId: string): string | null {
    const s = storage()
    if (!s || !placeId) return null
    try {
      return s.getItem(cacheKey(placeId))
    } catch {
      return null
    }
  },

  write(placeId: string, url: string | null): void {
    const s = storage()
    if (!s || !placeId) return
    try {
      if (url) s.setItem(cacheKey(placeId), url)
      else s.removeItem(cacheKey(placeId))
    } catch {
      // Quota or disabled storage — caching is best effort.
    }
  },

  clear(placeId: string): void {
    logoCache.write(placeId, null)
  },

  /** Resolves true once decoded, false if it cannot load. Never rejects. */
  preload(url: string | null): Promise<boolean> {
    if (!url) return Promise.resolve(false)
    return new Promise((resolve) => {
      const img = new Image()
      img.onload = () => {
        if (typeof img.decode === 'function') {
          img.decode().then(
            () => resolve(true),
            () => resolve(true),
          )
        } else {
          resolve(true)
        }
      }
      img.onerror = () => resolve(false)
      img.src = url
    })
  },
}
